var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"value":_vm.value,"items":_vm.lazyItems,"label":_vm.label,"error-messages":_vm.errorMessages,"return-object":_vm.returnObject,"loading":_vm.$apollo.queries.sources.loading,"disabled":_vm.disabled,"clearable":""},on:{"input":args => _vm.$emit('input', args),"focus":_vm.onFocus}})
}
var staticRenderFns = []

export { render, staticRenderFns }